
import React from 'react';
import TranslatedText from '@/TranslatedText';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const faqs = [
  {
    question: 'Who can become a seller on Ahavex?',
    answer: 'Any business registered in Rwanda or neighboring countries with quality products can apply to become an Ahavex seller. We particularly welcome manufacturers, artisans, and established brands.'
  },
  {
    question: 'What types of products can I sell?',
    answer: 'We accept a wide range of products across categories like electronics, fashion, home goods, beauty, food products, and locally made crafts. All products must meet our quality standards and comply with local regulations.'
  },
  {
    question: 'How does the commission structure work?',
    answer: 'Our commission rates vary by category, typically ranging from 8% to 15%. The exact rate depends on your product category, volume, and the services you need. We offer competitive rates compared to direct retail distribution.'
  },
  {
    question: 'How do I get my products to you?',
    answer: 'You can either deliver products to our warehouse or we can arrange pickup depending on your location and volume. We\'ll work out the most efficient logistics solution during the onboarding process.'
  },
  {
    question: 'When and how do I get paid?',
    answer: 'Payments are processed bi-weekly for all sales, minus applicable commissions. You\'ll receive payments via bank transfer to your registered business account. Our seller dashboard provides real-time visibility into your earnings.'
  },
  {
    question: 'What happens if products don\'t sell?',
    answer: 'We work with you to optimize pricing and promotions for slow-moving inventory. In some cases, products may be returned to you after a predetermined period, or we can discuss other arrangements like clearance sales.'
  }
];

const SellerFAQs: React.FC = () => {
  return (
    <div className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-3xl font-bold text-ahavex-blue mb-4">
            <TranslatedText text="Frequently Asked Questions" />
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            <TranslatedText 
              text="Get answers to common questions about selling on Ahavex"
            />
          </p>
        </div>
        
        <Accordion type="single" collapsible className="w-full max-w-3xl mx-auto">
          {faqs.map((faq, index) => (
            <AccordionItem key={index} value={`item-${index}`}>
              <AccordionTrigger className="text-left">
                <TranslatedText text={faq.question} />
              </AccordionTrigger>
              <AccordionContent>
                <TranslatedText text={faq.answer} />
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  );
};

export default SellerFAQs;
